export const INITIAL_REPOSITORY_DATA = {};
